import s from '@wix/communities-blog-client-common/src/styles/variables.scss';
import b from '@wix/communities-blog-client-common/src/styles/breakpoints.scss';

export const POST_PAGE_CONTAINER_PADDING = parseInt(s.postPageContainerPadding, 10);

export const POST_PAGE_PADDING = parseInt(s.postPagePadding, 10);
export const POST_PAGE_MIN_WIDTH = parseInt(s.postPageMinWidth, 10);
export const POST_PAGE_MAX_WIDTH = parseInt(s.postPageMaxWidth, 10);

export const POST_CONTENT_AREA_MIN_WIDTH = parseInt(s.postContentAreaMinWidth, 10);
export const POST_CONTENT_AREA_MAX_WIDTH = parseInt(s.postContentAreaMaxWidth, 10);

export const BREAKPOINT_POST_CONTENT_AREA_MIN = parseInt(b.breakpointPostContentAreaMin, 10);
export const BREAKPOINT_POST_CONTENT_AREA_SMALL = parseInt(b.breakpointPostContentAreaSmall, 10);

export const DEFAULT_POST_TITLE_FONT_SIZE_MOBILE = 26;
export const DEFAULT_POST_PAGE_FONT_SIZE_MOBILE = 16;
export const DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE = 24;
export const DEFAULT_POST_HEADER_THREE_SIZE_MOBILE = 20;
export const DEFAULT_POST_QUOTES_SIZE_MOBILE = 20;
